import _ from 'lodash';

import periodRanges from 'Constants/period-ranges';

export const periodTypes = _.toArray(periodRanges);
